// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__qEbIS","content":"LoadingAlert_content__3miDO"};